import { render, staticRenderFns } from "./tab-modulos.vue?vue&type=template&id=f654c634&"
import script from "./tab-modulos.vue?vue&type=script&lang=js&"
export * from "./tab-modulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports